/**
 * Limpa os caracteres especiais da string ".", "/", "-" e "_"
 * @param  {string} value
 * @returns string
 */
export function sanitize(value: string): string {
  return value.replace(/\./g, '').replace(/\-/g, '').replace(/\//g, '').replace(/\\/g, '').replace(/\_/g, '');
}
